<template>
    <main-layout>
        <template #header>
            <main-header :title="'매뉴얼 관리'">
            </main-header>
        </template>

        <template #toolbar>
        </template>

        <template #body>
            <div style="flex-grow: 0;">
                <v-tabs
                        v-model="tab"
                        background-color="primary"
                        dark
                >
                    <v-tab
                            key="PC"
                    >
                        PC 매뉴얼
                    </v-tab>
                    <v-tab
                            key="MOBILE"
                    >
                        Mobile 매뉴얼
                    </v-tab>
                </v-tabs>
            </div>

            <div style="flex-grow: 1;" class="fill-height">
                <v-tabs-items v-model="tab" class="fill-height">
                    <v-tab-item
                            class="fill-height"
                            key="PC"
                    >
                        <manual-manage-tab-content sort="PC"></manual-manage-tab-content>
                    </v-tab-item>
                    <v-tab-item
                            class="fill-height"
                            key="MOBILE"
                    >
                        <manual-manage-tab-content sort="MOBILE"></manual-manage-tab-content>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import MainHeader from "@/components/common/layout/MainHeader";
    import MainLayout from "@/components/common/layout/MainLayout";
    import ManualManageTabContent from "@/views/manual/manage/ManualManageTabContent";

    export default {
        name: "ManualManage",
        components: {ManualManageTabContent, MainLayout, MainHeader},
        data() {
            return {
                tab: "PC",
            };
        },
    }
</script>